<template>
  <div
    v-if="isShowBodyPain"
    class="body-pain">
    <h4 class="body-pain__heading">
      体の痛み
    </h4>
    <p class="body-pain__text">
      {{ activity.bodyPain.text }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true
    },
    bodyPainSetting: {
      type: Object,
      default: null
    },
  },
  computed: {
    isShowBodyPain() {
      if (this.bodyPainSetting === null || this.activity.bodyPain === null) return false
      return this.activity.bodyPain.text !== ''
    },
  },
}
</script>

<style lang="scss" scoped>
.body-pain {
  margin-bottom: 10px;
  &__heading {
    font-size: $fs-m;
    font-weight: bold;
    padding-bottom: 5px;
  }
  &__text {
    font-size: $fs-m;
    background: $text-background;
    padding: 5px 10px;
    width: 100%;
  }
}
</style>